import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {CreateBuilding} from "../../../reduxToolkit/Building/BuildingApi";
import {errorMsg} from "../../../Apis/functions";
import {BuildingFormApp} from "./BuildingFormApp";

/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 * A modal component for creating buildings with form inputs and validation.
 * The inputs and their handlers come from BuildingFormApp, shared with the update modal.
 * @module CreateBuildingModalApp
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.show - Controls modal visibility.
 * @param {Function} props.onHide - Callback for modal close event.
 * @param {Function} props.setModified - Flags the list to be reloaded after a successful creation.
 * @returns {Object} Returns an object containing:
 * - Localization function `t`
 * - UI elements and handlers for form management
 * - The form model `item` and its generic change handler
 */
export const CreateBuildingModalApp = (props) => {
    const {show, onHide, setModified} = props;

    // use hook importer
    const dispatch = useDispatch();

    const {t, item, handleChange, clearButton, handleCleanClick, emptyFields, setEmptyFields,
        getListStatus, employeeWorkStations, reset, showOverlay, overlayHiding, handleMouseEnter, handleMouseLeave, handleMapChange
    } = BuildingFormApp({
        show,
        cleanButtonId: 'btn_cbm_clean',
        useGeolocation: true
    });

    // a function to handel payload and dispatch api end function
    const handleCreateBuilding = () => {
        if (!item.isValid()) {
            setEmptyFields(true);
            return;
        }
        setEmptyFields(false);

        dispatch(CreateBuilding(item.toRegister())).then(({payload: {data: {success, code}}}) => {
            if (success) {
                toast.success(t('has_been_created_successfully'));
                setModified(true);
                reset();
                onHide();
            } else
                errorMsg(code);
        });
    };

    const handleClose = () => {
        reset();
        onHide();
    };

    return {
        t,
        item,
        handleChange,
        clearButton,
        handleCreateBuilding,
        handleCleanClick,
        emptyFields,
        getListStatus,
        employeeWorkStations,
        handleClose,
        showOverlay,
        overlayHiding,
        handleMouseEnter,
        handleMouseLeave,
        handleMapChange
    }

}
